import { useContext } from "react";

import { GlobalAnalysisNotificationsContext } from "./context";

const useGlobalAnalysisNotificationsContext = () => {
  const context = useContext(GlobalAnalysisNotificationsContext);
  if (!context) {
    throw new Error(
      "useGlobalAnalysisNotificationsContext must be used within GlobalAnalysisNotificationsProvider"
    );
  }
  return context;
};

export default useGlobalAnalysisNotificationsContext;
